// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"254":"80757677","257":"7293fdc7","453":"6eb6e7a0","517":"16068fb7","576":"c4607753"}[chunkId] + ".chunk.js";
};